import ImageInput from './ImageInput';
export default ImageInput;
